import { Box, Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { TextBold, TextMedium, TextRegular } from 'UiKit/typography';
import { Condition } from 'Component/others';
import { violationModalText } from 'Const/monitoring/view';
import usePostCameraViolation from 'Domain/monitoring/usePostCameraViolation';
import getCountUpTimeFormatter from 'Helper/getCountUpTimeFormatter';
import validateViolationImage from 'View/monitoring/helper/validateViolationImage';
import useFaceModel from 'Store/face-model';

import AudioViolation from 'View/monitoring/component/audio-violation';
import FaceTracking from 'View/monitoring/component/face-tracking';

import styles from './styles.module.css';
import { isEmpty } from 'lodash';

const ViolationModal = ({ onResetViolation, monitoringStatus, lastFacePositionRef, lastMovementTimeRef }) => {
  const COUNT_DOWN = 60;
  const TIME_PROGRESS = 5;

  const [timer, setTimer] = useState(COUNT_DOWN - TIME_PROGRESS);
  const [violationDuration, setViolationDuration] = useState(TIME_PROGRESS);

  const { mutate: onPostCameraViolation } = usePostCameraViolation();
  const { faceModel } = useFaceModel();

  const [isSpoofing, setIsSpoofing] = useState(false);

  const onTracking = (isFaceRecognize, isSpoofing) => {
    if (isFaceRecognize) onResetViolation();
    setIsSpoofing(isSpoofing);
  };

  const onPostViolation = async () => {
    if (isEmpty(faceModel)) return;

    const image = document.getElementById('video-stream');
    const payload = { ...monitoringStatus, image, isSpoofing };

    if (isSpoofing) return onPostCameraViolation(payload);

    const isValid = validateViolationImage({ faceModel, image });

    if (isValid) onPostCameraViolation(payload);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setTimer((prev) => prev - 1);
      setViolationDuration((prev) => prev + 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const isSendViolation = violationDuration % COUNT_DOWN === 0;

    if (isSendViolation && monitoringStatus) onPostViolation();
    /* eslint-disable */
  }, [monitoringStatus, violationDuration, isSpoofing, faceModel]);

  const isViolation = violationDuration > COUNT_DOWN;
  const violationDurationFormatted = getCountUpTimeFormatter(violationDuration);

  return (
    <Modal isOpen={true}>
      <ModalOverlay />
      <AudioViolation />

      <ModalContent maxWidth={'400px'}>
        <Box className={styles['violation-modal__container']}>
          <Box className={styles['violation-modal__section--head']}>
            <TextBold className={styles['title__text']}>{violationModalText.faceRecognizeText}</TextBold>
          </Box>
          <Box className={styles['violation-modal__section--content']}>
            <FaceTracking
              lastFacePositionRef={lastFacePositionRef}
              lastMovementTimeRef={lastMovementTimeRef}
              height="198px"
              width="352px"
              isOpen
              className={styles['camera__video']}
              onTracking={onTracking}
              isMonitoring
            />
          </Box>

          <Box className={styles['violation-modal__section--footer']}>
            <Condition statement={!isViolation}>
              <TextRegular className={styles['violation__text']}>{violationModalText.willGetViolationInText}</TextRegular>
              <TextMedium className={styles['number-second__text']}>{timer}</TextMedium>
              <TextMedium className={styles['second__text']}>detik</TextMedium>
            </Condition>

            <Condition statement={isViolation}>
              <TextMedium className={styles['violation-duration__text']}>{violationDurationFormatted}</TextMedium>
              <TextRegular className={styles['violation__text']}>{violationModalText.violationNotesAfter60Second}</TextRegular>
            </Condition>
          </Box>
        </Box>
      </ModalContent>
    </Modal>
  );
};

export default ViolationModal;
